import React from 'react';

import classes from './PrizesBlock.module.scss';
import { CollapsableInfoBox } from '../../../../shared/components/ui-components';
import { RichTextViewer } from '../../../../shared/features/rich-text';
import { ChallengePrizesInfo } from '../../../interfaces/ChallengeInfo';

type PrizesBlockProps = {
  defaultOpen: boolean;
  prizes: ChallengePrizesInfo;
};

const PrizesBlock = ({ defaultOpen, prizes }: PrizesBlockProps) => {
  const prizeList = prizes.prizes ?? [];

  if (!prizes.enabled || prizeList.length === 0) {
    return null;
  }

  return (
    <CollapsableInfoBox
      title="Prizes"
      defaultOpen={defaultOpen}
      customMargin
      customContentPadding
    >
      <div className={classes.prizesContainer}>
        {prizeList.map((prize) => (
          <div key={prize.prizeNum} className={classes.prizeItem}>
            <p className={classes.title}>{prize.title}</p>
            <RichTextViewer content={prize.description} />
          </div>
        ))}
      </div>
    </CollapsableInfoBox>
  );
};

export { PrizesBlock };
